
<main class="d-flex align-items-center min-vh-100 py-3 py-md-0" style="width: 100%;">
  <div class="container">
    <div class="card login-card">
      <div class="row no-gutters">
        

        <div class="col-md-12 terms-container">
        <header class="terms-header">
            <div class="header-content">
                <div class="logo-section">
                    <img src="assets/images/logo-lg-afh.png" alt="AFH Myaccount" class="logo">
                </div>
                <nav class="breadcrumb">
                    <a href="javascript:void(0)" routerLink="/public/oauth2">Accueil</a> > <a href="javascript:void(0)">Légal</a> > <span>Conditions d'Utilisation</span>
                </nav>
            </div>
        </header>

        <div class="terms-content" style="height: 600px; overflow: auto;">
            <div class="content-header">
                <h1>Conditions d'Utilisation du Service AFH Myaccount</h1>
                <div class="meta-info">
                    <span class="last-update">Dernière mise à jour : <strong>20.03.2024</strong></span>
                </div>
            </div>

            <div class="toc-container">
                <h3>Table des matières</h3>
                <nav class="toc-nav">
                <a [routerLink]="[]" fragment="acceptation" class="toc-link">1. Acceptation des Conditions</a>
                <a [routerLink]="[]" fragment="description" class="toc-link">2. Description du Service</a>
                <a [routerLink]="[]" fragment="compte" class="toc-link">3. Votre Compte AFH Myaccount</a>
                <a [routerLink]="[]" fragment="consentement" class="toc-link">4. Processus de Consentement et Partage de Données</a>
                <a [routerLink]="[]" fragment="engagements" class="toc-link">5. Engagements de l'Utilisateur</a>
                <a [routerLink]="[]" fragment="propriete" class="toc-link">6. Propriété intellectuelle</a>
                <a [routerLink]="[]" fragment="responsabilite" class="toc-link">7. Limitation de responsabilité</a>
                <a [routerLink]="[]" fragment="modifications" class="toc-link">8. Modifications des Conditions</a>
                <a [routerLink]="[]" fragment="contact" class="toc-link">9. Contact</a>
                </nav>
            </div>

            <article class="terms-article">
                <section id="acceptation" class="terms-section">
                    <h2>1. Acceptation des Conditions</h2>
                    <p>En utilisant le service d'authentification AFH Myaccount (ci-après dénommé "le Service"), vous acceptez sans réserve les présentes Conditions d'Utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le Service pour vous connecter aux plateformes des entreprises du groupe AFH et de ses partenaires.</p>
                </section>

                <section id="description" class="terms-section">
                    <h2>2. Description du Service</h2>
                    <p>AFH Myaccount est un service d'authentification centralisé, basé sur le protocole OAuth2, développé et maintenu par le groupe AFH. Son rôle est de permettre aux utilisateurs de se connecter de manière sécurisée et unifiée à l'ensemble des plateformes et applications des entreprises du groupe AFH et de ses partenaires autorisés.</p>
                </section>

                <section id="compte" class="terms-section">
                    <h2>3. Votre Compte AFH Myaccount</h2>
                    <div class="subsection">
                        <h3>3.1. Création de compte</h3>
                        <p>Pour utiliser le Service, vous devez créer un compte personnel AFH Myaccount.</p>
                    </div>
                    <div class="subsection">
                        <h3>3.2. Responsabilité du compte</h3>
                        <p>Vous êtes responsable de la confidentialité des informations de votre compte (identifiant et mot de passe) et de toutes les activités qui en découlent.</p>
                    </div>
                    <div class="subsection">
                        <h3>3.3. Exactitude des informations</h3>
                        <p>Vous vous engagez à fournir des informations exactes et à les maintenir à jour.</p>
                    </div>
                </section>

                <section id="consentement" class="terms-section">
                    <h2>4. Processus de Consentement et Partage de Données</h2>
                    <div class="subsection">
                        <h3>4.1. Définition des données requises</h3>
                        <p>Lorsque vous utilisez AFH Myaccount pour vous connecter à une application partenaire (ci-après "l'Application Client"), cette dernière définit les données de profil dont elle a besoin.</p>
                    </div>
                    <div class="subsection">
                        <h3>4.2. Transparence du partage</h3>
                        <p>Avant toute connexion, le Service vous présentera clairement la liste des informations que l'Application Client souhaite accéder.</p>
                    </div>
                    <div class="subsection">
                        <h3>4.3. Consentement explicite</h3>
                        <p>Vous devez expressément consentir à partager ces informations avec l'Application Client pour que l'autorisation d'accès vous soit accordée.</p>
                    </div>
                    <div class="subsection">
                        <h3>4.4. Gestion du consentement</h3>
                        <p>Votre consentement est spécifique à chaque Application Client. Vous pouvez le gérer ou le révoquer à tout moment depuis les paramètres de votre compte AFH Myaccount.</p>
                    </div>
                </section>

                <section id="engagements" class="terms-section">
                    <h2>5. Engagements de l'Utilisateur</h2>
                    <p>En utilisant le Service, vous vous engagez à :</p>
                    <ul class="commitments-list">
                        <li>Ne pas utiliser le Service à des fins illégales ou non autorisées.</li>
                        <li>Ne pas tenter de compromettre l'intégrité ou la sécurité du Service.</li>
                        <li>Ne pas usurper l'identité d'un autre utilisateur.</li>
                    </ul>
                </section>

                <section id="propriete" class="terms-section">
                    <h2>6. Propriété intellectuelle</h2>
                    <p>Le Service AFH Myaccount, incluant son code, son interface graphique et sa marque, est la propriété exclusive du groupe AFH et est protégé par les lois sur la propriété intellectuelle.</p>
                </section>

                <section id="responsabilite" class="terms-section">
                    <h2>7. Limitation de responsabilité</h2>
                    <p>Le groupe AFH s'efforce de maintenir le Service accessible et sécurisé. Cependant, il ne peut être tenu responsable des interruptions temporaires ou définitives du Service, ou des dommages indirects pouvant en résulter.</p>
                </section>

                <section id="modifications" class="terms-section">
                    <h2>8. Modifications des Conditions</h2>
                    <p>Le groupe AFH se réserve le droit de modifier les présentes Conditions d'Utilisation à tout moment. Les utilisateurs seront informés des modifications et leur utilisation continue du Service vaudra acceptation des nouvelles conditions.</p>
                </section>

                <section id="contact" class="terms-section">
                    <h2>9. Contact</h2>
                    <p>Pour toute question relative à ces Conditions d'Utilisation, vous pouvez nous contacter à : <strong>[support@afhunt.com]</strong>.</p>
                </section>
            </article>

            
        </div>

        </div>


      </div>
    </div>
  </div>
</main>